import { render, staticRenderFns } from "./detailManage.vue?vue&type=template&id=131816b3&scoped=true&"
import script from "./detailManage.vue?vue&type=script&lang=js&"
export * from "./detailManage.vue?vue&type=script&lang=js&"
import style0 from "./detailManage.vue?vue&type=style&index=0&id=131816b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131816b3",
  null
  
)

export default component.exports